import React, { useEffect, useState } from 'react';
import _ from 'lodash';
// import { useAuthStore } from '../../auth/stores';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import { isAuth, logout } from '../../auth/actions';

const menusData = [
  {
    title: 'Dashboard',
    icon: 'la la-laptop',
    to: '/home',
  },
  {
    title: 'Theme Management',
    icon: 'la la-palette',
    to: '/theme-management',
  },
  {
    title: 'Template Management',
    icon: 'la la-table',
    to: '/template-management',
  },
  {
    title: 'Employee Management',
    icon: 'la la-user-tie',
    to: '/employee-management',
  },
  {
    title: 'Customer Management',
    icon: 'la la-users',
    to: '/customer-management',
  },
];

const filterAccessMenuData = (newMnu) => {
  if (!_.isArray()) {
    console.log('Oops, something wrong just happen');
  }
  menusData.forEach((mnu) => {
    if (mnu) {
      newMnu.push(mnu);
    }
  });
};

const getInitials = function (string) {
  if (string) {
    var names = string ? string.split(' ') : '',
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
};

export function LeftMenu() {
  // const [authState, authActions] = useAuthStore();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  let accessMenuData = [];

  // console.log('ini user', user);

  filterAccessMenuData(accessMenuData);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const token = user?.token;

    //cek token expires
    if (token) {
      const decodeToken = decode(token);

      if (decodeToken.exp * 1000 < new Date().getTime()) {
        handleLogout();
      }
    }

    setUser(JSON.parse(localStorage.getItem('profile')));
  }, [location]);

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    history.push('/auth');

    setUser(null);
  };

  return (
    <>
      <aside className='hidden lg:flex menu-bar menu-sticky menu-wide'>
        <div className='menu-items'>
          <div className='menu-header'>
            <Link to='/home' className='flex items-center mx-8 mt-8'>
              <span className='avatar w-16 h-16'>
                {isAuth().name ? getInitials(isAuth().name) : ''}
              </span>
              <div className='ml-4 text-left text-gray-700 dark:text-gray-500'>
                <h4>{isAuth().name}</h4>
                <div className='flex items-center mt-1 w-40'>Admin</div>
              </div>
            </Link>
            <hr className='mx-8 my-4' />
          </div>

          {accessMenuData.map((item, idx) => (
            <Link to={item.to} className='link' key={idx}>
              <span className={`icon ${item.icon}`}></span>
              <span className='title'>{item.title}</span>
            </Link>
          ))}

          <button
            onClick={() => logout(() => history.push('/auth/login'))}
            type='button'
            className='link'
          >
            <span className='icon la la-power-off text-red-500'></span>
            <span className='title text-red-500'>Logout</span>
          </button>
        </div>
      </aside>

      <aside className='lg:hidden menu-bar menu-sticky'>
        <div className='menu-items'>
          {accessMenuData.map((item, idx) => (
            <Link to={item.to} className='link' key={idx}>
              <span className={`icon ${item.icon}`}></span>
              <span className='title'>{item.title}</span>
            </Link>
          ))}

          <button onClick={() => logout(() => history.push('/auth/login'))} type='button' className='link w-full'>
            <span className='icon la la-power-off'></span>
            <span className='title'>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}
